import { GoalSuccessEvent } from 'constantsBase';
import { GoalSectionAction, GoalSectionActionTypes } from './types';

export const updateRevenueTypeEnabled = (isEnabled: boolean): GoalSectionAction => ({ type: GoalSectionActionTypes.UPDATE_REVENUE_TYPE_ENABLED, payload: isEnabled });
export const updateRevTypeSearchStr = (searchStr: string): GoalSectionAction => ({ type: GoalSectionActionTypes.UPDATE_REV_TYPE_SEARCH_STR, payload: searchStr });
export const updateSuccessEventFilter = (successEvent: GoalSuccessEvent | 'all'): GoalSectionAction => ({ type: GoalSectionActionTypes.UPDATE_SUCCESS_EVENT_FILTER, payload: successEvent });
